import { render, staticRenderFns } from "./navbar-yleinen-laskuri.vue?vue&type=template&id=317fc108&scoped=true&"
import script from "./navbar-yleinen-laskuri.vue?vue&type=script&lang=ts&"
export * from "./navbar-yleinen-laskuri.vue?vue&type=script&lang=ts&"
import style0 from "./navbar-yleinen-laskuri.vue?vue&type=style&index=0&id=317fc108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317fc108",
  null
  
)

export default component.exports